module.exports = __webpack_public_path__ + "img/index_5.77830b85.jpg";